import api from '../../gql/api';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { setEventGroups } from '../slices/eventGroups';
import { setCurrentWorkspaceEventGroupIds } from '../slices/currentWorkspace';
import _ from 'lodash';

export const getEventGroupByWorkspaceId = createAsyncThunk(
  'monitoring/getEventGroupByWorkspaceId',
  async (payload, { dispatch }) => {
    const {
      workspaceId,
      setLoading = () => {},
      setErrors = () => {},
    } = payload;

    if (!_.isEmpty(workspaceId)) {
      setLoading(true);
      try {
        const response = await api.eventGroup.getEventGroupByWorkspaceId({
          workspaceId,
        });

        if (response.data.getEventGroupsByWorkspaceId?.eventGroups) {
          dispatch(
            setEventGroups(
              response.data.getEventGroupsByWorkspaceId.eventGroups
            )
          );

          dispatch(
            setCurrentWorkspaceEventGroupIds(
              response.data.getEventGroupsByWorkspaceId.eventGroups.map(
                (resolution) => resolution.id
              )
            )
          );

          setLoading(false);
          return response.data.getEventGroupsByWorkspaceId.eventGroups;
        }
      } catch (error) {
        setErrors(error.message);
        setLoading(false);
        return null;
      }
    } else {
      setErrors('generalError');
      setLoading(false);
      return null;
    }
    return null;
  }
);

export const createEventGroup = createAsyncThunk(
  'eventGroups/createEventGroup',
  async (payload) => {
    const eventGroupCreated = await api.eventGroup.createEventGroup({
      data: payload,
    });
    return eventGroupCreated.data.createEventGroup;
  }
);

export const deleteEventGroupById = createAsyncThunk(
  'eventGroups/deleteEventGroupById',
  async (payload) => {
    const { id } = payload;
    const eventGroupDeleted = await api.eventGroup.deleteEventGroupById({ id });
    return eventGroupDeleted.data.deleteEventGroupById;
  }
);

export const updateEventGroupById = createAsyncThunk(
  'eventGroups/updateEventGroupById',
  async (payload) => {
    const { id, data } = payload;
    const eventGroupUpdated = await api.eventGroup.updateEventGroupById({
      id,
      data,
    });

    return eventGroupUpdated.data.updateEventGroupById;
  }
);
